import type { SvgType } from './types'

export default function Print({ fill, style, size, viewBox }: SvgType) {
  return (
    <svg
      aria-hidden="true"
      width={size}
      height={size}
      style={style}
      viewBox={viewBox}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <path
          fill={fill}
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7 4.5C7 4.22386 7.22386 4 7.5 4H16.5C16.7761 4 17 4.22386 17 4.5V7V7.5V8H16.5H7.5H7V7.5V7V4.5ZM3 11C3 9.89543 3.89543 9 5 9H19C20.1046 9 21 9.89543 21 11V14V15V17H19H17V21H7V17H5H3V15V14V11ZM8 15H16V20H8V15ZM20 11.5C20 12.3284 19.3284 13 18.5 13C17.6716 13 17 12.3284 17 11.5C17 10.6716 17.6716 10 18.5 10C19.3284 10 20 10.6716 20 11.5Z"
        />
        <mask
          id="mask0"
          maskUnits="userSpaceOnUse"
          x={3}
          y={4}
          width={18}
          height={17}
        >
          <path
            fill={fill}
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7 4.5C7 4.22386 7.22386 4 7.5 4H16.5C16.7761 4 17 4.22386 17 4.5V7V7.5V8H16.5H7.5H7V7.5V7V4.5ZM3 11C3 9.89543 3.89543 9 5 9H19C20.1046 9 21 9.89543 21 11V14V15V17H19H17V21H7V17H5H3V15V14V11ZM8 15H16V20H8V15ZM20 11.5C20 12.3284 19.3284 13 18.5 13C17.6716 13 17 12.3284 17 11.5C17 10.6716 17.6716 10 18.5 10C19.3284 10 20 10.6716 20 11.5Z"
          />
        </mask>
      </g>
    </svg>
  )
}
